module.exports = __webpack_public_path__ + "static/media/partner06.a0c63ad5.svg";